const listDetailsElem = document.querySelectorAll('.mega-menu.details > summary');
const listContentsElem = document.querySelectorAll('.mega-menu__content');

const listDetails = document.querySelectorAll('details');
const menuIcon = document.querySelector('.icon-menu-close');
const backButton = document.querySelectorAll('header-drawer .back-button');

if(backButton) {
    backButton.forEach(button => {
        button.addEventListener('click', () => {
            const headerDraw = document.querySelector('header-drawer .menu-drawer__navigation-container');
            const currentMenuLevelNumber = headerDraw?.getAttribute('data-level');
            if (headerDraw && currentMenuLevelNumber) {
                const currentMenuElement = headerDraw.querySelector(`details[data-level="${currentMenuLevelNumber}"]`);
                button.closest('details').removeAttribute('open');

                if (currentMenuElement) {
                    headerDraw.setAttribute('data-level', `${currentMenuLevelNumber - 1}`);
                }
            }
        });
    });
}

if(menuIcon) {
    menuIcon.addEventListener('click', () => {
        const menuContainers = document.querySelectorAll('header-drawer details:not(.menu-drawer__level2)');
        const headerDraw = document.querySelector('header-drawer .menu-drawer__navigation-container');
        menuContainers.forEach(container => {
            container.removeAttribute('open');
        });
        headerDraw?.removeAttribute('data-level');
    });
}
listDetails.forEach(item => {
    item.addEventListener('toggle', function() {

        if (!this.open) {
            listContentsElem.forEach(item => {
                item.classList.remove('menu-opening');
                item.parentElement.classList.remove('menu-opening');
            });
            SublistContentsElem.forEach(item => {
                item.classList.remove('menu-opening');
                item.parentElement.classList.remove('menu-opening');
            });
        }
        if (this.open) {
            const dataLevel = this.getAttribute('data-level');
            const headerDraw = document.querySelector('header-drawer .menu-drawer__navigation-container');
            if (headerDraw && dataLevel && !this.classList.contains('menu-drawer-container')) {
                headerDraw.setAttribute('data-level', dataLevel);
            }
        }
    });
});


listDetailsElem.forEach(item => {
    item.addEventListener('click', function() {
        listContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });

        const content = this.nextElementSibling;
            content.classList.toggle('menu-opening');
        this.parentElement.classList.add('menu-opening');
    });
});


const SublistDetailsElem = document.querySelectorAll('.mega-menu__item.details > summary');
const SublistContentsElem = document.querySelectorAll('.mega-menu__item .mega-menu__content');

SublistDetailsElem.forEach(item => {
    item.addEventListener('click', function() {
        SublistContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });

        const content = this.nextElementSibling;
        content.classList.toggle('menu-opening');
        this.parentElement.classList.add('menu-opening');
    });
});

const myElement = document.querySelector('.main-menu');
document.addEventListener('click', function(event) {
    if (!event.isTrusted) return;
    if (!myElement.contains(event.target)) {
        listContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });
        SublistContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
  // Select all mega menu <details> elements
  const megaMenus = document.querySelectorAll('.mega-menu details');

  document.addEventListener('click', function (event) {
    // Ignore synthetic clicks dispatched by third-party scripts (e.g. Boost Commerce search widget),
    // which would otherwise close the open mega menu unexpectedly.
    if (!event.isTrusted) return;
    megaMenus.forEach(details => {
      // If the click is outside the <details> element and it's open, close it
      if (details.open && (!details.contains(event.target) || event.target.classList.contains('menu-overlay'))) {
        details.removeAttribute('open');
      }
    });
  });
});
